import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RESULTPAGEMESSAGE } from '@common/constants';
import { IResultPageState } from '@common/models';
import { ResultService } from '@common/services';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/common.service';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { RetailStock } from 'src/app/retail-common.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  protected resultstate: Partial<IResultPageState> = {};
  isFavorite: boolean;
  currentFavInvNo: any;
  isAdd: boolean = true;

  constructor(
    private _router: Router,
    public _resultService: ResultService,
    private _navigationService: NavigationService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    private _commonService: CommonService,
    private _retailStock: RetailStock
  ) {
    
  }

  ngOnInit(): void {
    this._commonService.hideSpinner();
    this.resultstate = this._resultService.resultPageData;
    // if(this.resultstate.alertType === 'Success'){
      //this.resultstate.message = RESULTPAGEMESSAGE[this.resultstate.serviceCode];
      // let resultMessage = this.translate.instant('RESULTPAGEMESSAGE.' + this.resultstate.serviceCode);
      // if (this.resultstate.serviceCode == 'INTBTBENEADD' || this.resultstate.serviceCode == 'ACHBENEADD' || this.resultstate.serviceCode == 'SWIFTBENEADD') {
      //   this.isAdd = false;
      // }
      // else {
      //   this.isAdd = true;
      // }
      // if (this.resultstate.successMsgNumber) resultMessage = resultMessage.replace('successMsgNumber', this.resultstate.successMsgNumber);
      // this.resultstate.message = resultMessage;
    // };
    this._resultService.resetResultData();
    if (this._commonService.isDesktop()) {
      this._retailStock.backBtnUrl = ['home', 'transactions'];
    }
  }

  resultButtonClickHandler(navDetails): void {
    if(this._navigationService.getCardDetails) this._navigationService.checkNavigation = true;
    this._resultService.refNo = undefined; // account number show for open new CA<SA and DA
    try {
      this._router.navigate(navDetails.path, {
        queryParams: navDetails.queryParams,
        queryParamsHandling: 'preserve',
      });
      this._resultService.backUrl = undefined;
      if(Object.keys(this.dialogRef).length) this.dialogRef.close();
    } catch (err) {
      console.error(err);
    }
  }
  makeAsFavourite(resultstate) {
    if(this.isFavorite && resultstate) {
      this._resultService.makeUnFavoritePayment(this.currentFavInvNo).subscribe(
        (res)=>{
          this.isFavorite = !this.isFavorite;
          this.currentFavInvNo = res.favouritepayments.inventoryNo;
          console.log(res);
        }
      );
      return;
    }
    
    this._resultService.makeFavoritePayment().subscribe(
      (res)=>{
        this.isFavorite = !this.isFavorite;
        this.currentFavInvNo = res.favouritepayments.inventoryNo;
        console.log(res);
      }
    );
    console.log(resultstate);
  }
  ngOnDestroy() {
    this._retailStock.backBtnUrl = undefined;
  }
}
